export default function StatisticsCard({ title, value, subValue = "", icon, bgColor }) {
  return (
    <div>
      <div className="flex gap-3">
        <div
          className={`flex justify-center items-center w-[45px] h-[45px] rounded-lg shrink-0 ${bgColor || "bg-primary"}`}
        >
          {icon}
        </div>
        <div>
          <p className="text-title text-xl">{value || 0}</p>
          <p className="text-sm font-medium text-gray-500 capitalize">{title}</p>
          {subValue ? (
            <p className="text-xs text-gray-400 mt-0.5">{subValue}</p>
          ) : null}
        </div>
      </div>
    </div>
  );
}
